module.exports = __webpack_public_path__ + "static/media/bgBox.3a78062c.jpg";